'use client'
import React, {useContext} from "react"
import Image from "next/image"
import {GlassBox} from "@/ui/components/custom/box"
import {GLOBAL_PATHS} from "@/lib/globals"
import {TranslationContext} from "@/configs/context"
import {Box, Grid, Typography, useMediaQuery, useTheme} from "@mui/material"


const ValuesSection: React.FC = () => {
  const theme = useTheme()
  // @ts-ignore
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))
  const imageSize = 14*12

  const values = [
    {
      title: t('translation:values.title1'),
      img: `${GLOBAL_PATHS.GLASS2}4644647.webp`,
      // img: `${GLOBAL_PATHS.GLASS}8715093.webp`,
      // img: `${GLOBAL_PATHS.IMAGES}9324888.webp`,
      content: t('translation:values.content1')
    },
    {
      title: t('translation:values.title2'),
      img: `${GLOBAL_PATHS.GLASS2}4644639.webp`,
      // img: `${GLOBAL_PATHS.GLASS}8715095.webp`,
      // img: `${GLOBAL_PATHS.IMAGES}9618905.webp`,
      content: t('translation:values.content2')
    },
    {
      title: t('translation:values.title3'),
      img: `${GLOBAL_PATHS.GLASS2}4644630.webp`,
      // img: `${GLOBAL_PATHS.GLASS}8715071.webp`,
      // img: `${GLOBAL_PATHS.IMAGES}9890622.webp`,
      content: t('translation:values.content3')
    },
  ]

  return (
    <React.Suspense fallback={<div />}>
      <Box
        id="value-section"
        sx={{
          pt: { xs: 6, md: 6 },
          pb: { xs: 6, md: 6 },
          color: "text.primary",
        }}
      >
        <Typography
          variant="h4"
          sx={{ textAlign: "center", marginBottom: "2rem" }}
        >
          {t('translation:values.title')}
        </Typography>

        <Grid container spacing={3} alignItems="stretch">
          {values.map((value, index) => (
            <Grid
              key={value.title}
              size={{
                xs: 12, md: 4,
                sm: index === values.length - 1 ? 12 : 6,
              }}
            >
              <GlassBox 
                sx={{
                  display: "flex",
                  alignItems: "stretch",
                  height: { md: "100%" },
                  flexDirection: "column", 
                  justifyContent: "flex-end",
                  pb: { md: theme.spacing(0) },
                }}
              >
                <Typography variant={matchMd ? "h5" : "h6"}>
                  {value.title}
                </Typography>
                <Typography
                  align="left"
                  sx={{ mb:1, marginTop: "1rem", flexGrow: 3,  }}
                  variant={matchMd ? "body1" : "body2"}
                >
                  {value.content}
                </Typography>
                <Box sx={{ 
                  flexGrow: 3, 
                  alignItems: "end",
                  justifyContent: "center",
                  display: "flex"
                }}>
                  <Image
                    alt=""
                    src={value.img}
                    width={imageSize}
                    height={imageSize}
                    style={{ borderRadius: "16px" }}
                  />
                </Box>
              </GlassBox>
            </Grid>
          ))}
        </Grid>
      </Box>
    </React.Suspense>
  )
}

export default ValuesSection
